import Dexie, { Table } from 'dexie';
import { StorageAPI } from './StorageAPI';
import { Team } from '../types';

export class DexieStorage extends Dexie implements StorageAPI {
  teams!: Table<Team, string>;

  constructor() {
    super('BBTacticsDB');
    this.version(1).stores({
      teams: 'id, teamName, coachName'
    });
    this.teams = this.table('teams');
  }

  async listTeams(): Promise<Team[]> {
    return this.teams.toArray();
  }

  async saveTeam(team: Team): Promise<string> {
    const now = new Date().toISOString();
    const record: Team = {
      ...team,
      id: team.id || crypto.randomUUID(),
      createdAt: team.id ? team.createdAt : now,
      updatedAt: now,
    };
    await this.teams.put(record);
    return record.id;
  }

  async deleteTeam(id: string): Promise<void> {
    await this.teams.delete(id);
  }
}
